<ng-container *ngIf="!init; else assetsDisplay">
  <mat-spinner color="primary" diameter="24"></mat-spinner>
</ng-container>

<ng-template #assetsDisplay>
  <file-picker
    [uploadButtonLabel]="'Foto toevoegen'"
    [offlineUpload]="true"
    [emitOfflineAssets]="true"
    [disabled]="disabled || storingOfflineChange"
    [disabledErrorMessage]="
      storingOfflineChange
        ? 'Lokale verandering aan het opslaan, gelieve zo dadelijk opnieuw te proberen'
        : 'Gelieve de uitvoering eerst te starten'
    "
    (assetsAdded)="onAssetsAdded($event)"
  >
  </file-picker>

  <ng-container *ngIf="assets?.length > 0">
    <div
      *ngFor="let asset of assets; index as i; let first = first"
      [class.remove-top-margin]="first"
      matTooltip="{{ asset.name }}"
    >
      <div class="d-flex box click-link max-image-width">
        <a
          download="{{ asset.name }}"
          [href]="asset.uuid | assetSource : asset.localSafeUrl"
          style="margin-right: 7px"
          class="d-flex box"
        >
          <div class="filename">
            {{ asset.name | shortenTextSplitOn : '.' : 10 }}
          </div>

          <a>
            <mat-icon aria-hidden="false" aria-label="remove">
              cloud_download
            </mat-icon>
          </a>
        </a>

        <a *ngIf="!disabled && !storingOfflineChange">
          <mat-icon class="clickable" (click)="removeAsset(i)">
            delete
          </mat-icon>
        </a>
      </div>

      <div>
        <img
          class="clickable max-image-width max-image-height"
          *ngIf="isImage(asset)"
          [src]="asset.uuid | assetSource : asset.localSafeUrl"
          (click)="openLightbox(i)"
        />
      </div>
    </div>
  </ng-container>
</ng-template>
